import type { BoxProps } from '@mui/material/Box';
import { Iconify } from '@/components/iconify';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Category } from '@/types/Category';
import React from 'react';
import { Markdown } from '@/components/markdown/markdown';

// ----------------------------------------------------------------------

type FaqsListProps = BoxProps & {
  category?: Category;
};

export function FaqsList({ sx, category, ...other }: FaqsListProps) {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  return (
    <Box sx={{...sx, textAlign: 'left'}} {...other}>
      {category && category.faqs && category.faqs.map((faq, index) => (
        <Accordion key={`faq-${index}`} expanded={expanded === `faq-${index}`} onChange={handleChange(`faq-${index}`)}>
          <AccordionSummary expandIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}>
            <Typography variant="subtitle1">{faq.question}</Typography>
          </AccordionSummary>

          <AccordionDetails>
            <Markdown
              children={faq.answer}
              sx={[
                () => ({
                  '& p, li, ol, table': { typography: 'body2' },
                  '& table': {
                    mt: 2,
                    maxWidth: 640,
                    '& td': { px: 2 },
                    '& td:first-of-type': { color: 'text.secondary' },
                    'tbody tr:nth-of-type(odd)': { bgcolor: 'transparent' },
                  },

                }),
                ...(Array.isArray(sx) ? sx : [sx]),
              ]}
            />
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}
